import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';
import App from './App';
import './index.css';
import { I18nProvider } from './lib/i18n';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: (count, err: any) => (err?.status >= 400 && err?.status < 500 ? false : count < 2) },
  },
});

// A data router enables navigation blocking for unsaved admin edits; <App/> declares the routes.
const router = createBrowserRouter([{ path: '*', element: <App /> }]);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <I18nProvider>
        <RouterProvider router={router} />
        <Toaster richColors position="top-center" closeButton />
      </I18nProvider>
    </QueryClientProvider>
  </StrictMode>,
);
